import { acVersionReleasesTypes } from '../acReduxExports';

const versionReleaseInitialState: AcVersionReleaseState = {
    versionReleases: null,
    versionReleasesCount: 0,
    latestVersionInfo: null,
    latestVersionInfoLoader: false,
    chargerOnVersionTrendProductTypeHash: null,
    chargerOnVersionTrendFilterHash: null,
    chargerOnVersionTrendLoader: false,
    chargerOnVersionTrendInfo: null,
    deploymentProgressTrendProductTypeHash: null,
    deploymentProgressTrendFilterHash: null,
    deploymentProgressTrendLoader: false,
    deploymentProgressTrendInfo: null,
    deploymentLogsFiltersAppliedFromRedirection: false,
    versionReleaseListRequestFilterHash: null,
    versionReleaseListRequestSearchHash: null,
    versionReleaseTableListLoader: false,
    versionReleaseTableProps: {
        view: 'list',
        sortBy: 'releaseDate',
        order: 'descending',
        pageSize: 15,
        pageNumber: 1,
        searchTerm: null,
    },
    versionReleaseFiltersAppliedFromRedirection: false,
  deploymentLogs: null,
  deploymentLogsCount: 0,
  deploymentLogTableProps: {
    view: 'list',
    sortBy: 'requestedOn',
    order: 'descending',
    pageSize: 15,
    pageNumber: 1,
    searchTerm: null
  },
  deploymentLogTableListLoader: false,
  deploymentLogListRequestSearchHash: null,
  deploymentLogListRequestFilterHash: null,
};

const acVersionReleasesReducer = (
    state: AcVersionReleaseState = versionReleaseInitialState,
    action: AcVersionReleaseAction,
): AcVersionReleaseState => {
    switch (action.type) {
        case acVersionReleasesTypes.FETCH_LATEST_AC_VERSION_INFO_DATA:
            return {
                ...state,
                latestVersionInfo: action.latestVersionInfo,
            };
        case acVersionReleasesTypes.SET_LATEST_AC_VERSION_INFO_LOADER:
            return {
                ...state,
                latestVersionInfoLoader: action.latestVersionInfoLoader || false,
            };
        case acVersionReleasesTypes.SET_AC_CHARGER_ON_VERSION_TREND_FILTER_HASH:
            return {
                ...state,
                chargerOnVersionTrendProductTypeHash:
                    action.chargerOnVersionTrendProductTypeHash,
                chargerOnVersionTrendFilterHash: action.chargerOnVersionTrendFilterHash,
            };
        case acVersionReleasesTypes.SET_AC_CHARGER_ON_VERSION_TREND_LOADER:
            return {
                ...state,
                chargerOnVersionTrendLoader:
                    action.chargerOnVersionTrendLoader || false,
            };
        case acVersionReleasesTypes.FETCH_AC_CHARGER_ON_VERSION_TREND_DATA:
            return {
                ...state,
                chargerOnVersionTrendInfo: action.chargerOnVersionTrendInfo,
            };
        case acVersionReleasesTypes.SET_AC_DEPLOYMENT_PROGRESS_TREND_FILTER_HASH:
            return {
                ...state,
                deploymentProgressTrendFilterHash:
                    action.deploymentProgressTrendFilterHash,
                deploymentProgressTrendProductTypeHash:
                    action.deploymentProgressTrendProductTypeHash,
            };
        case acVersionReleasesTypes.SET_AC_DEPLOYMENT_PROGRESS_TREND_LOADER:
            return {
                ...state,
                deploymentProgressTrendLoader:
                    action.deploymentProgressTrendLoader || false,
            };
        case acVersionReleasesTypes.FETCH_AC_DEPLOYMENT_PROGRESS_TREND_DATA:
            return {
                ...state,
                deploymentProgressTrendInfo: action.deploymentProgressTrendInfo,
            };
        case acVersionReleasesTypes.SET_AC_DEPLOYMENT_LOGS_FILTERS_APPLIED_FROM_REDIRECTION:
            return {
                ...state,
                deploymentLogsFiltersAppliedFromRedirection:
                    action.deploymentLogsFiltersAppliedFromRedirection || false,
            };
        case acVersionReleasesTypes.SET_AC_VERSION_RELEASE_TABLE_LIST_LOADER:
            return {
                ...state,
                versionReleaseTableListLoader:
                    action.versionReleaseTableListLoader || false,
            };
        case acVersionReleasesTypes.SET_AC_VERSION_RELEASE_LIST_REQUEST_HASH:
            return {
                ...state,
                versionReleaseListRequestSearchHash:
                    action.versionReleaseListRequestSearchHash || null,
                versionReleaseListRequestFilterHash:
                    action.versionReleaseListRequestFilterHash || null,
            };
        case acVersionReleasesTypes.FETCH_AC_VERSION_RELEASE_DATA:
            return {
                ...state,
                versionReleases: action.versionReleases,
                versionReleasesCount: action.versionReleasesCount || 0,
            };

        case acVersionReleasesTypes.SET_AC_VERSION_RELEASE_TABLE_PROPS:
            return {
                ...state,
                versionReleaseTableProps:
                    action.versionReleaseTableProps || state.versionReleaseTableProps,
            };

        case acVersionReleasesTypes.SET_AC_VERSION_RELEASE_FILTERS_APPLIED_FROM_REDIRECTION:
            return {
                ...state,
                versionReleaseFiltersAppliedFromRedirection:
                    action.versionReleaseFiltersAppliedFromRedirection || false,
            };
        case acVersionReleasesTypes.FETCH_AC_DEPLOYMENT_LOGS_DATA:
            return {
                ...state,
                deploymentLogs: action.deploymentLogs,
                deploymentLogsCount: action.deploymentLogsCount || 0,
            };
        case acVersionReleasesTypes.SET_AC_DEPLOYMENT_LOGS_TABLE_LIST_LOADER:
            return {
                ...state,
                deploymentLogTableListLoader: action.deploymentLogTableListLoader || false,
            };
        case acVersionReleasesTypes.SET_AC_DEPLOYMENT_LOGS_LIST_REQUEST_HASH:
            return {
                ...state,
                deploymentLogListRequestSearchHash: action.deploymentLogListRequestSearchHash || null,
                deploymentLogListRequestFilterHash: action.deploymentLogListRequestFilterHash || null,
            };
        case acVersionReleasesTypes.SET_AC_DEPLOYMENT_LOGS_TABLE_PROPS:
            return {
                ...state,
                deploymentLogTableProps: action.deploymentLogTableProps || state.deploymentLogTableProps,
            };
        case acVersionReleasesTypes.CLEAR_AC_DEPLOYMENT_LOGS_DATA:
            return {
                ...state,
                deploymentLogs: null,
                deploymentLogsCount: 0,
            };
        default:
            return state;
    }
};

export default acVersionReleasesReducer;